import React from 'react';
import {
  AppBar,
  Box,
  makeStyles,
  Toolbar,
} from '@material-ui/core';
import { Spinner } from 'src/components/Loaders';
import Logo from 'src/components/Logo';
import Footer from 'src/views/HomePage/Footer';
import MockToggle from 'src/components/MockToggle';

const useStyles = makeStyles((theme) => ({
  root : {
    display:"flex",
    flexDirection:"column",
    minHeight:"100vh",
    backgroundColor:theme.palette.background.default
  },
  appBar: {
		backgroundColor: "inherit",
		// zIndex: theme.zIndex.drawer + 100,
    height:64,
	},
	toolbar: {
		height: 64,
	},
  content : {
    position:"relative",
    paddingTop:64,
    flex:1,
    display:"flex",
    alignItems:"center",
    justifyContent:"center"
  }
}));


const PlaintLayout: React.FC = ({children}) => {

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} elevation={0}>
        <Toolbar className={classes.toolbar}>
          <Logo />
          <MockToggle/>
        </Toolbar>
      </AppBar>
      <Box className={classes.content}>
        {children}
      </Box>
      {/* <Box flex={1}/> */}
      {/* <div style={{backgroundColor:"#141719"}}> */}
      <Footer/>
      {/* </div> */}
    </div>
  )
}

export default PlaintLayout;
